import React from 'react';
import { Header } from 'semantic-ui-react';

const SubHeader = () => (
	<div>
		<Header textAlign="center" size="tiny" as="h2">
			JavaScript Developer
		</Header>
	</div>
);

export default SubHeader;



// WEBPACK FOOTER //
// ./src/components/SubHeader.js